
























import { postArticle } from '@/api/api';
import { Component, Vue } from 'vue-property-decorator';
import { addTypeContract } from '@/api/api'
import ArticlesDatatable from '@/components/ArticlesDatatable.vue';
@Component({
    components: {
        ArticlesDatatable
    },
})
export default class Contracts extends Vue {
    showAddArticle = false;
    error = '';
    reload = false;
    article = {
        label: '',
        price_ht: null
    }

    async post() {
        const $vs = (this as any).$vs;

        if (!this.article.label || !this.article.price_ht) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                //@ts-ignore
                text: "Veuillez remplir tout les champs!",
            });
            return;
        }

        try {
            const { data } = await postArticle(this.article)
            console.log(data)

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Création',
                text: `Création de l'article réussie`,
            });
            this.reload = true;
            this.showAddArticle = false;
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                //@ts-ignore
                text: error.response.data.message,
            });
            return;
        }
    }
}
